import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation  } from 'react-router-dom';

import * as scheduleApi from '../../../api/schedule';
import { makeNewBooking } from '../../../api/booking';
import { findGuestByRequest } from '../../../api/guest'
// import * as branchApi from '../../../api/branch';
import {useHistory } from 'react-router-dom/cjs/react-router-dom'; // Link,  

import HeaderFeature from '../../Unit/HeaderFeature';
import ReservationRoomStyleComponent from '../../../components/Reservation/ReservationRoomStyle';
import ReservationShowDateComponent from '../../../components/Reservation/ReservationShowDate';
// import ReservationTotal from '../../../components/Reservation/ReservationTotal';
import ReservationScheduleComponent from '../../../components/Reservation/ReservationSchedule';
import ReservationScheduleComponent2 from '../../../components/Reservation/ReservationSchedule/ReservationScheduleComponent2';
import ReservationScheduleComponent3 from '../../../components/Reservation/ReservationSchedule/ReservationScheduleComponent3';

import { reservationAction, dataPickUpAction, modalAction, unitsAction } from '../../../redux/actions/index';
import { coverBranchIDToFullName, checkBranchIDHaveOnArea } from '../../../utils/Branch/SupportBranch';

import { getTodayMonth, increaseTodayWithNumber, checkMonthWithOther2Day, getToday,  } from '../../../utils/Date/SupportDate';
import { LIST_BRANCH_WITH_AREA, SELECT_KEEP_WITH_BRANCH_ID } from '../../../constaints/listID/listID';
import './reservation.css';
import loadingCat from '../../../assests/img/loading-cat.gif';
// // import loadingDuck from '../../../assests/img/duck2.gif';
import { io } from "socket.io-client";
import ModalNotify from '../../../features/ModalNotify';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || window.location.origin;

ReservationContainer.propTypes = {
};

function ReservationContainer() {
    const dispatch = useDispatch();
    const location = useLocation();
    const reservationPath = location.pathname.split('/')[1] === 'reservation_test2' ? '/reservation_test2' : '/reservation';
    const ScheduleComponent = reservationPath === '/reservation_test2'
        ? ReservationScheduleComponent3
        : location.pathname.split('/')[1] === 'reservation_test'
            ? ReservationScheduleComponent2
            : ReservationScheduleComponent;
    let history = useHistory();
    const socketRef = useRef(null);

    //console.log("location", location.pathname)

    // const [showComponentDate, setShowComponentDate] = useState(false);
    // const [showComponentA, setShowComponentA] = useState(false);
    const [showComponentB, setShowComponentB] = useState(false);
    const [showComponentC, setShowComponentC] = useState(false);
    const [showComponentD, setShowComponentD] = useState(false);
    const [realtime, setRealtime] = useState(false);
    const [showRealtimeLostNotice, setShowRealtimeLostNotice] = useState(false);
    // NOTE: lưu đúng cell room+day mới update để animate đúng ô ngày vừa thay đổi
    const [newRealtimeCells, setNewRealtimeCells] = useState([]);
    // NOTE: lưu booking id mới để animate nguyên block booking gộp (vd R401 span 3 ngày)
    const [newRealtimeBookingIds, setNewRealtimeBookingIds] = useState([]);
    const dataBranchOnState = useSelector(state => state.dataPickUp.reservation);
    const allBranchInform = LIST_BRANCH_WITH_AREA;//useSelector(state => state.allBranch);

    const token = useSelector(state => state.token);
    const auth = useSelector(state => state.auth);
    useSelector(state => state.branchInfor);
    const { role, area } = auth.user;
    const { branchIDParam, month,  } = useParams();
    const branchID = branchIDParam ? branchIDParam : auth.user.branchID;
    const scheduleData = useSelector(state => state.reservation);

   // console.log("scheduleData", scheduleData)
  //  const isMultiBranch = (role === 5 || role === 6 || role === 7 || role === 8 || role === 1);
    const isMultiBranch = (role === 5 || role === 6);
    const isMultiArea = (role === 7 || role === 1 || role === 8);
    const allowRealtimeAnimation = Number(branchID) === 99;

    const listArea = allBranchInform === undefined ? [] : Object.keys(allBranchInform);
    var listBranch = (role === 6 || role === 5) ? renderListBranch(area) :
        (role === 7 || role === 8) ? renderListBranch(dataBranchOnState.area) :
            (role === 4 && branchID === 1) ? ["Thai Van Lung 1", "Annex"] : [];

    var [selectRoomType, setSelectRoomType] = useState("All");
    const listTips = [
        "Please clear Waiting List make by Azumaya VietNam Website",
        // "Check Waiting List with booking by membership",
        // "Use LOCK ROOM profile form maintent, problem room, not sale room....",
        // "Use MAKE ROOM STATUS button if you want make same schedule",
        // "Please clear waiting list make by system Azumayavietnam.com",
        // "New Database have 3 area: Schedule + Waiting + Cancel",
        // "Can sort many schedule use Sort Button",
        // "Small icon support quick view guest information",
    ]

    function showRealtimeDisconnectedNotice() {
        setRealtime(false);
        setShowRealtimeLostNotice(true);
    }

    function handleUseOfflineMode() {
        setShowRealtimeLostNotice(false);
    }

    function handleReloadPage() {
        window.location.reload();
    }

    function extractRealtimeCellList(data, selectedMonth) {
        const cellSet = new Set();
        const bookingIdSet = new Set(data?.listBookingID || []);

        let targetRoomList = [];
        let realtimeRoomData = {};

        if(data?.dateThisMonth === selectedMonth) {
            targetRoomList = data?.thisMonthListRoomNeedCheckRealtime || [];
            realtimeRoomData = data?.thisMonthRealtime || {};
        } else if(data?.dataNextMonth === selectedMonth) {
            targetRoomList = data?.nextMonthListRoomNeedCheckRealtime || [];
            realtimeRoomData = data?.nextMonthRealtime || {};
        } else {
            targetRoomList = data?.otherMonthListRoomNeedCheckRealtime || [];
            realtimeRoomData = data?.otherMonthRealtime || {};
        }

        targetRoomList.forEach((roomNumber) => {
            const roomData = realtimeRoomData?.[roomNumber] || [];

            roomData.forEach((cellData, index) => {
                if(cellData && typeof cellData === 'object' && cellData.id && bookingIdSet.has(cellData.id)) {
                    cellSet.add(`${roomNumber}__${selectedMonth}-${String(index + 1).padStart(2, '0')}`);
                }
            });
        });

        return Array.from(cellSet);
    }

    const loadSchedule = useCallback(async (branchID, month) => { //2023-07-Test
        dispatch(reservationAction.resetRsvtData())

        dispatch(unitsAction.showLoading());
        const findSchedule = reservationPath === '/reservation_test2'
            ? scheduleApi.findGuestDataOnScheduleTest2
            : scheduleApi.findGuestDataOnSchedule;
        const takeGuestDataList = await findSchedule(branchID, month, month, token);
       // dispatch(unitsAction.hiddenLoading());
        dispatch(reservationAction.fillRsvtData({
            schedule: takeGuestDataList.data.scheduleData,
            //  dataSchedule.data.data,
            turnLoadingRoom: takeGuestDataList.data.turnLoadingRoom,
            listReservation: takeGuestDataList.data.listReservation,
            listWaiting : takeGuestDataList.data.listWaiting,
            listCancel : takeGuestDataList.data.listCancel
        }));

        //dispatch(unitsAction.hiddenLoading());
    }, [dispatch, token, reservationPath]);

    const checkDataBranch = useCallback(() => {
        let newDataBranch ;
        
        if(isMultiArea || isMultiBranch) {
            const checkMultiBranchID = branchID ? (isMultiBranch ? (checkBranchIDHaveOnArea(branchID, area, "check") ? branchID : 0) : branchID) : 0;

            newDataBranch = {
                month: month ? month : getTodayMonth(),
                typeView: "month", // glist, week, selected,
                branchID: branchID ? checkMultiBranchID : 0,
                branch: branchID ? checkMultiBranchID === 0 ? "Select Branch" : coverBranchIDToFullName(Number(branchID)) : "Select Branch", //
                area: isMultiBranch ? area :  (branchID ? checkBranchIDHaveOnArea(branchID, "", "find") : "Select Area"),
            }
            if(newDataBranch.branchID === 0 && month) alert("Error branch data !! Please select branch")
            else if(month) loadSchedule(newDataBranch.branchID, month);
            else {}
            dispatch(dataPickUpAction.changeDataReservation(newDataBranch));
        
        } else {
            newDataBranch = {
                month: month ? month : getTodayMonth(),
                typeView: "month", // glist, week, selected,
                branchID: auth.user.branchID,
                branch: "Select Branch",
                area: "Select Area",
            }
            dispatch(dataPickUpAction.changeDataReservation(newDataBranch));
            loadSchedule(auth.user.branchID, newDataBranch.month);
        }
    }, [isMultiArea, isMultiBranch, branchID, area, month, dispatch, auth.user.branchID, loadSchedule]);

    useEffect(() => {
            let animationEndTimeout;

            const socket = io(SOCKET_URL,{ reconnection: false  });
            // const socket = io("https://database.azumayareport.com/",{  reconnection: false,})

            socketRef.current = socket;

            socket.on("join_branch_success", () => {
                setRealtime(true);
                setShowRealtimeLostNotice(false);
            });

            socket.on("disconnect", () => {
                showRealtimeDisconnectedNotice();
            });

            socket.on("connect_error", () => {
                showRealtimeDisconnectedNotice();
            });

            socket.emit("join_branch", {
                branchID,
                userName: auth.user?.name || '',
                role: auth.user?.role ?? null,
                page: window.location.pathname,
                source: 'reservation-realtime',
            });    
            socket.on("booking:new", (data) => {
            // NOTE: lấy đúng cell room+day để animate đúng ô ngày vừa thay đổi

          //  console.log("📩 Received new booking realtime data:", data);

            const realtimeCells = allowRealtimeAnimation ? extractRealtimeCellList(data, dataBranchOnState.month) : [];
            const realtimeBookingIds = allowRealtimeAnimation ? (data?.listBookingID || []) : [];
            if(allowRealtimeAnimation && (realtimeCells.length > 0 || realtimeBookingIds.length > 0)) {
                setNewRealtimeCells(realtimeCells);
                setNewRealtimeBookingIds(realtimeBookingIds);
                clearTimeout(animationEndTimeout);
                animationEndTimeout = setTimeout(() => {
                    setNewRealtimeCells([]);
                    setNewRealtimeBookingIds([]);
                }, 2600);
            }

            if(data.dateThisMonth === dataBranchOnState.month) {
                // console.log("vo here check realtime this month")
                dispatch(reservationAction.checkRealtime({
                    changeType: "update",
                    data: data
                }));                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
            } else if (data.dataNextMonth === dataBranchOnState.month) {
                // console.log("go to data next month realtime")
                dispatch(reservationAction.checkRealtime({
                    changeType: "update",
                    data: data
                }));
            } else {
                // if(data.othMonth.length > 0) {}
                // check this month have change data
                // call api load data again
                function isMonthInStay(selectedMonth, checkin, checkout) {
                    const monthStart = new Date(selectedMonth + "-01");
                    const monthEnd = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 0);

                    const checkinDate = new Date(checkin);
                    const checkoutDate = new Date(checkout);

                    return (monthStart <= checkoutDate) && (monthEnd >= checkinDate);
                }

                const otherMonthListRoomNeedCheckRealtime = Array.isArray(data?.otherMonthListRoomNeedCheckRealtime)
                    ? data.otherMonthListRoomNeedCheckRealtime
                    : [];

                const listRoomNeedCheckReadtime = [];
                const callRealtimeForOtherMonth = async () => {
                    const takeGuestDataList = await scheduleApi.checkRealtime(branchID, dataBranchOnState.month, {
                        listSchedule: otherMonthListRoomNeedCheckRealtime,
                        listBookingID: data?.listBookingID || [],
                    },token);

                    if(data.otherMonthRealtimeRedo !== "") {
                        takeGuestDataList.data.data.otherMonthRealtimeRedo = data.otherMonthRealtimeRedo;
                    }

                    dispatch(reservationAction.checkRealtime({
                        changeType: "update",
                        data: takeGuestDataList.data.data
                    }));
                }

                otherMonthListRoomNeedCheckRealtime.forEach(roomData => {
                    const checkMonthGuestStay = isMonthInStay(dataBranchOnState.month, roomData.checkin, roomData.checkout);

                    if(checkMonthGuestStay) {
                        // console.log("check here 1")
                        listRoomNeedCheckReadtime.push(roomData.roomSelect);
                    }
                });

                if(listRoomNeedCheckReadtime.length > 0) {
                //  console.log("check here 2")
                    callRealtimeForOtherMonth();
                }
                // check list guest have stay
            }
                });

            // socket.on("reconnect", () => {
            //     console.log("🔄 Reconnected — syncing data...");
            //     window.location.reload();
            // });

            const handleBrowserOnline = () => {
                window.location.reload();
            };

            const handleBrowserOffline = () => {
                showRealtimeDisconnectedNotice();
            };

            window.addEventListener("online", handleBrowserOnline);
            window.addEventListener("offline", handleBrowserOffline);
            
            // ✅ cleanup khi rời trang
            return () => {
                clearTimeout(animationEndTimeout);
                window.removeEventListener("online", handleBrowserOnline);
                window.removeEventListener("offline", handleBrowserOffline);
                socket.emit("leave_branch", { branchID });
                setRealtime(false)
                setShowRealtimeLostNotice(false);
                setNewRealtimeCells([]);
                setNewRealtimeBookingIds([]);
                socket.disconnect();
            };
            

     }, [allowRealtimeAnimation, dataBranchOnState.month, branchID, auth.user, dispatch, token]);

     useEffect(() => { 
        if (role !== undefined) checkDataBranch();
     }, [role, checkDataBranch]);

    function renderListBranch(areaValue) {
        let list = [];
        if (JSON.stringify(allBranchInform) !== '{}' && areaValue !== "Select Area") {
            if (listArea.length > 0) {  
                allBranchInform[areaValue].forEach(branch => {
                    list.push(branch.name);
                })
            }
        } else {
            list = []
        }
        return list;
    }

    function callApiQuickMakeRoom(dataQuick, roomSelect, checkin) {
        console.log("dataQuick", dataQuick)
        console.log("roomSelect", roomSelect)
        console.log("checkin", checkin)

        function calculateCheckoutDate(checkinDateStr, nights) {
            const checkin = new Date(checkinDateStr);
            checkin.setDate(checkin.getDate() + Number(nights));
            const year = checkin.getFullYear();
            const month = String(checkin.getMonth() + 1).padStart(2, '0'); // Tháng trong JS tính từ 0-11
            const day = String(checkin.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

        const dataBody = {
            "pickUp": {
                "time": "",
                "flight": "",
                "price": 0
            },
            "dropOff": {
                "time": "",
                "flight": "",
                "price": 0
            },
            "rentCarList": [],
            "changeRentCar": false,
            "vat": false,
            "remarkVAT": "",
            "status": "waiting",
            "confirm": false,
            "isMakeHI": false,
            "area": "schedule",
            "color": "black",
            "maker": dataQuick.maker,
            "count": 2,
            "mail": "it@azumayavietnam.com" ,
            "viewPassPort": true,
            "indexGuestSelect": 0,
            "listGuestSelect": [],
            "listRoomPrice": {
                "101": 1200000,
                "102": 1625000,
                "103": 1625000,
                "104": 1300000,
                "105": 1375000,
                "106": 1500000,
                "107": 1375000,
                "201": 1200000,
                "202": 1625000,
                "203": 1625000,
                "204": 1300000,
                "205": 1375000,
                "206": 1500000,
                "207": 1375000,
                "301": 1200000,
                "302": 1625000,
                "303": 1625000,
                "304": 1300000,
                "305": 1375000,
                "306": 1500000,
                "307": 1375000,
                "401": 1200000,
                "402": 1625000,
                "403": 1625000,
                "404": 1300000,
                "405": 1375000,
                "406": 1500000,
                "407": 1375000,
                "501": 1200000,
                "502": 1625000,
                "503": 1625000,
                "504": 1300000,
                "505": 1375000,
                "506": 1500000,
                "507": 1375000,
                "601": 1200000,
                "602": 1625000,
                "603": 1625000,
                "604": 1300000,
                "605": 1375000,
                "606": 1500000,
                "607": 1375000
            },
            "listBranchArea": [],
            "payment": "individual",
            "request1": "",
            "request2": dataQuick.note,
            "scheduleSelect": 0,
            "listSchedule": [
                {
                "roomSelect": roomSelect,
                "move": false,
                "discount": 0,
                "price": 1500000,
                "checkin": checkin,
                "checkout": calculateCheckoutDate(checkin, dataQuick.night),
                "nights": dataQuick.night,
                "shortime": false,
                "earlyCheckin": false,
                "lateOut": false,
                "timeEarly": "15:00",
                "timeLateOut": "12:00",
                "timeShortTime": ""
                }
            ],
            "branchID": branchID
        }

        const makeNew = async () => {
            const checkProfile = await findGuestByRequest("id", dataQuick.type === "lock" ? SELECT_KEEP_WITH_BRANCH_ID[Number(branchID) === 99 ? "lockTest" :"lock"] 
                : SELECT_KEEP_WITH_BRANCH_ID[branchID], token);
            dataBody.listGuestSelect = checkProfile.data;
            await makeNewBooking( branchID, dataBody, token);
        }

        makeNew();
    }

    const handleComponentAFinish = () => { 
        dispatch(unitsAction.hiddenLoading());
         setShowComponentB(true); 
    };
    
    const handleComponentBFinish = () => { 
        dispatch(unitsAction.hiddenLoading());
        setShowComponentC(true); 
    };

    const handleComponentCFinish = () => {

        if(showComponentD === false) {
            changeScroll();
        }
        setShowComponentD(true);

        async function changeScroll() {
            
            const today = getTodayMonth();
            const checkMonth = checkMonthWithOther2Day(today, scheduleData.month);

            if (checkMonth === 1) {
                window.scrollTo(900, 0);
                dispatch(unitsAction.hiddenLoading());
                // setShowComponentB(true); 
           } else {
               const dayOfToday = getToday().slice(8, 10);
               if (Number(dayOfToday) < 10) {
                     window.scrollTo(0, 0);
               } else if (Number(dayOfToday) > 10 && Number(dayOfToday) < 20) {
                    window.scrollTo(400, 0);
               } else {
                    window.scrollTo(1200, 0);
               }
             dispatch(unitsAction.hiddenLoading());
              //setShowComponentB(true); 
           }
        }
    };



    function onChangeDataSelect(value, target, option) {
        let branchIdSelect;

        if (role === 0 || role === 3 || role === 4 || role === 2) {
            branchIdSelect = auth.user.branchID;
        } else {
            if (target  === "branch") {
                const areaFindIndex = dataBranchOnState.area === "Select Area" ? area : dataBranchOnState.area;
                const findIndex = allBranchInform[areaFindIndex].findIndex(({ name }) => name === value);
                branchIdSelect = allBranchInform[areaFindIndex][findIndex].branchID;
            }
        }

        let newData;

        if((value === 1 || value === -1) && target === "month") { 
            newData = {
                ...dataBranchOnState,
                month: increaseTodayWithNumber(dataBranchOnState.month, "month", value).slice(0,7)
            };
        } else {
            newData = {
                ...dataBranchOnState,
                branchID: branchIdSelect,
                ["" + target]: value
            };
        }

        if(target === "area") {
            newData.branchID = 0;
            newData.branch = "Select Branch";
        }

        dispatch(dataPickUpAction.changeDataReservation(newData));

        if (target === "month") {
            if (role === 0 || role === 3 || role === 4 || role === 2) {
                history.push(`${reservationPath}/${newData.branchID}/${newData.month}`);
                loadSchedule(newData.branchID, newData.month);
            } else {
                history.push(`${reservationPath}/${dataBranchOnState.branchID}/${newData.month}`);
                loadSchedule(dataBranchOnState.branchID, newData.month);
            }

        }
    }

    function onTakeLinkLoadDataOtherBranch() {
        if (role === 7 && location.pathname !== `/reservation_test2/${dataBranchOnState.branchID}/${dataBranchOnState.month}`) {
            return;
        } else if (role === 99 && location.pathname !== `/reservation_test2/${dataBranchOnState.branchID}/${dataBranchOnState.month}`) {
            return;
        }
        loadSchedule(dataBranchOnState.branchID, dataBranchOnState.month);
    }

    function checkTitle() {
        const currentBranchID = Number(branchID || auth.user.branchID);
        const currentBranchName = coverBranchIDToFullName(currentBranchID).toUpperCase();
        const canUseRealtime = true; //BRANCH_RUN_REALTIME.includes(currentBranchID);

        return (
            <h1>
                {"AZUMAYA " + currentBranchName}{" "}
                {canUseRealtime ? (
                    realtime ? (
                        <span className="realtime-pulse">{"<<Realtime>>"}</span>
                    ) : (
                        <span style={{
                            display: 'inline-block',
                            marginLeft: '8px',
                            padding: '3px 10px',
                            borderRadius: '999px',
                            fontSize: '14px',
                            fontWeight: 700,
                            color: '#8a4b00',
                            background: '#fff4e5',
                            border: '1px solid #ffb74d',
                            verticalAlign: 'middle'
                        }}>
                            Offline mode
                        </span>
                    )
                ) : ""}
            </h1>
        );
    }

    function closeModal() { dispatch(modalAction.modalReset()); }
    function openModal() { dispatch(modalAction.modalIsOk()); }

    return (
        <>
        <ModalNotify closeModal={closeModal} />
        
        <div style={{width:'maxContent'}} className='rsv-container'>
            {showRealtimeLostNotice && (
                <div style={{
                    position: 'fixed',
                    fontSize: '1.5rem',
                    top: '18px',
                    right: '40%',
                    zIndex: 9999,
                    width: 'min(420px, calc(100vw - 32px))',
                    background: '#fff4e5',
                    border: '1px solid #ffb74d',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
                    borderRadius: '12px',
                    padding: '30px'
                }}>
                    <div style={{ fontSize:'1.8rem', fontWeight: 700, color: '#8a4b00', marginBottom: '8px' }}>
                        Realtime connection was lost
                    </div>
                    <div style={{ color: '#5f3700', lineHeight: 1.5, marginBottom: '14px' }}>
                        The schedule is still available in offline mode, but it may not receive the newest realtime updates.
                    </div>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleUseOfflineMode}
                        >
                            Use offline
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleReloadPage}
                        >
                            Reload page
                        </button>
                    </div>
                </div>
            )}
            {
                dataBranchOnState.loading ? "" : 
                        <div className='d-flex'>
                        <div className="rp__title" style={{ width: '50px'}}>
                            <HeaderFeature
                                feature1={onChangeDataSelect}
                                feature2={onTakeLinkLoadDataOtherBranch}
                                loadDataPath={role === 7 || Number(dataBranchOnState.branchID) === 99 ? '/reservation_test2' : '/reservation'}
                                dataBranchOnState={dataBranchOnState}
                                type="reservation"
                                data = {{
                                        listArea,          
                                        listBranch,
                                        isMulti : isMultiArea || isMultiBranch,
                                        }}
                                title={checkTitle() }
                            />
                        </div>
                    </div>
            }
            {
                ((isMultiBranch || isMultiArea) && branchID === undefined && dataBranchOnState.branchID === 0) ?
                    <div style={{marginTop: '48px', position:'fixed', width:'100%'}}>
                        <img
                        alt="not data"
                        src='https://database.azumayareport.com/img/logo/show_home.png'
                        width="500px"/>
                        <h2>Have not reservation show, please select again branch</h2>
                    </div> :
                        !scheduleData.loading ?
                        <div className="d-flex">
                            <ReservationRoomStyleComponent
                                data={scheduleData}
                                branchID={branchID}
                                selectRoomType={selectRoomType}
                                setSelectRoomType={setSelectRoomType}
                            />
                            <div className="rsv">
                                <ReservationShowDateComponent
                                    type="reservation"
                                   // onFinish={handleComponentDateFinish} 
                                    data={scheduleData} />

                                            <ScheduleComponent
                                                data={scheduleData}
                                                onFinish={handleComponentAFinish} 
                                                listRender = "listReservation"
                                                openModal={openModal}
                                                callApiQuickMakeRoom={callApiQuickMakeRoom}
                                                renderNumber =  {1}
                                                branchID={branchID}
                                                showComponent={true}
                                                selectRoomType={selectRoomType}
                                                newRealtimeCells={newRealtimeCells}
                                                newRealtimeBookingIds={newRealtimeBookingIds}
                                                />

                            {showComponentB ? <ScheduleComponent
                                    data={scheduleData}
                                    onFinish={handleComponentBFinish} 
                                    callApiQuickMakeRoom={callApiQuickMakeRoom}
                                    listRender = "listReservation"
                                    renderNumber =  {2}
                                    selectRoomType={selectRoomType}
                                    showComponent={showComponentB}
                                    newRealtimeCells={newRealtimeCells}
                                    newRealtimeBookingIds={newRealtimeBookingIds}
                                /> : <div style={{color:"", marginTop:"24px",fontSize:"1.5rem"}}>Loading ...</div>}

                                {showComponentC && <ReservationShowDateComponent
                                    type="waiting"
                                    data={scheduleData} /> }

                                {showComponentC ? <ScheduleComponent
                                    data={scheduleData}
                                    listRender = "listWaiting"
                                    onFinish={handleComponentCFinish} 
                                    selectRoomType={selectRoomType}
                                    showComponent={showComponentC}
                                /> : <div style={{color:"", marginTop:"24px",fontSize:"1.5rem"}}>Loading waiting list...</div>}

                                {showComponentD && <ReservationShowDateComponent
                                    type="cancel"
                                    data={scheduleData} /> }

                                {showComponentD ? <ScheduleComponent
                                    data={scheduleData}
                                    listRender = "listCancel"
                                    selectRoomType={selectRoomType}
                                    showComponent={showComponentD}
                                /> : <div style={{color:"", marginTop:"24px",fontSize:"1.5rem"}}>Loading Cancel List...</div> } 
                                <br/>
                                <br/>
                            </div>
                        </div> : <div style={{marginTop: '54px', position:'fixed', width:'100%', }}>
                            <img
                            alt="Have not data"
                            src={Number(auth.user.branchID) === 99 ? loadingCat :'https://database.azumayareport.com/img/logo/show_home.png'}
                            width="500px"/>

                            {<h2>{listTips[Math.floor(Math.random() * listTips.length)]}</h2>}
                            {/* {Number(auth.user.branchID) === 99 ? <h2>Check waiting with booking by membership</h2>: <h2>If can't load data, please logout and login again</h2>} */}
                            {<h2>If can't load data, please logout and login again</h2>}
                    </div>
            }
        </div>

        </>
    );
}

export default ReservationContainer;
